/* tslint:disable */
import {
  Category
} from '../index';

declare var Object: any;
export interface ActualInterface {
  "id"?: number;
  "name"?: string;
  "value"?: number;
  "typeid"?: number;
  "categoryid"?: number;
  "budgetid"?: number;
  "time"?: Date;
  "userid"?: number;
  "createdat"?: Date;
  "updatedat"?: Date;
  "memo"?: string;
  "image"?: string;
  category?: Category;
}

export class Actual implements ActualInterface {
  "id": number;
  "name": string;
  "value": number;
  "typeid": number;
  "categoryid": number;
  "budgetid": number;
  "time": Date;
  "userid": number;
  "createdat": Date;
  "updatedat": Date;
  "memo": string;
  "image": string;
  category: Category;
  constructor(data?: ActualInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Actual`.
   */
  public static getModelName() {
    return "Actual";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Actual for dynamic purposes.
  **/
  public static factory(data: ActualInterface): Actual{
    return new Actual(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Actual',
      plural: 'Actuals',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'number'
        },
        "typeid": {
          name: 'typeid',
          type: 'number'
        },
        "categoryid": {
          name: 'categoryid',
          type: 'number'
        },
        "budgetid": {
          name: 'budgetid',
          type: 'number'
        },
        "time": {
          name: 'time',
          type: 'Date'
        },
        "userid": {
          name: 'userid',
          type: 'number'
        },
        "createdat": {
          name: 'createdat',
          type: 'Date'
        },
        "updatedat": {
          name: 'updatedat',
          type: 'Date'
        },
        "memo": {
          name: 'memo',
          type: 'string'
        },
        "image": {
          name: 'image',
          type: 'string'
        },
      },
      relations: {
        category: {
          name: 'category',
          type: 'Category',
          model: 'Category'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk-budget/models/Actual.ts